module.exports = __webpack_public_path__ + "static/media/cover.ccc8f568.png";